const NO_FUNNEL_NAME = 'No funnel name provided'

export function getBannerFunnelName(bannerLink: string) {
  if (!bannerLink || !bannerLink.includes('quiz')) {
    return NO_FUNNEL_NAME
  }
  const [path] = bannerLink.split('?')
  const linkSegments = path?.split('/')
  return linkSegments?.pop() || NO_FUNNEL_NAME
}
